import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  MAT_CHECKBOX_DEFAULT_OPTIONS,
  MatCheckboxChange,
  MatCheckboxDefaultOptions,
} from '@angular/material/checkbox';
import { GlobalConstants } from '@globalConstants';
import { IPeriodResults } from '@interfaces/IPeriodResults';

@Component({
  selector: 'app-table-student-results',
  templateUrl: './table-student-results.component.html',
  styleUrls: ['./table-student-results.component.sass'],
  providers: [
    {
      provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
      useValue: { clickAction: 'check' } as MatCheckboxDefaultOptions,
    },
  ],
})
export class TableStudentResultsComponent {
  @Input() results: IPeriodResults[] | [] = [];
  @Input() showSelectedPeriod = false;
  @Input() showSelectedAllPeriod = false;
  @Input() isAll = false;
  @Input() selected?: Set<number>;
  @Output() selectItem = new EventEmitter<{
    id: number;
    number: number;
    event: MatCheckboxChange;
  }>();
  @Output() selectAllItems = new EventEmitter<MatCheckboxChange>();
  readonly studentsWorkStatus = GlobalConstants.StudentHomeworkOrExamStatus;

  select(e: MatCheckboxChange, period: { id: number; number: number }) {
    this.selectItem.emit({ ...period, event: e });
  }

  selectAll(e: MatCheckboxChange) {
    this.selectAllItems.emit(e);
  }

  isSelected(id: number): boolean {
    if (!this.selected) return false;

    return this.selected.has(id);
  }
}
